import React from 'react'
import { injectState } from 'freactal'
import app from '../../../../feathers'
import { hasElement, sectionDisplayIndex } from '../../../../lib'
import { Checkbox } from 'react-mdl'
import styled from 'styled-components'

const LabelTd = styled.td`
  text-align: center;
  margin: 5px;
  font-weight: bold;
  text-decoration: underline;
`

const units = app.service('units')
class FormativeTheoryContent extends React.Component {
  state = {
    formativeTheoryMapping: [],
  }

  componentDidMount() {
    this.initialMapping()
  }

  componentWillReceiveProps() {
    this.initialMapping()
  }

  initialMapping = () => {
    const theoryQuestionsBySection = (section, sectionIndex) => {
      const questionsArr = []
      const processSection = (
        { subsections = [], questions = [] },
        sectionIndex,
      ) => {
        const reviewQuestions = questions.reduce((carry, question, i) => {
          if (question.type === 'review') {
            carry.push({
              mapping: question.mapping,
              questionIndex: i,
              sectionIndex,
            })
          }
          return carry
        }, [])
        questionsArr.push(...reviewQuestions)
        subsections.forEach((section, j) =>
          processSection(section, [...sectionIndex, j]),
        )
      }
      section.subsections.forEach((section, i) =>
        processSection(section, [...sectionIndex, i]),
      )
      return questionsArr
    }
    const questionsBySections = this.props.state.unit.sections.map(
      (section, i) => theoryQuestionsBySection(section, [i]),
    )
    this.setState({ formativeTheoryMapping: questionsBySections })
  }

  handleChangeTheoryMapping = async (e, sectionIndex, questionIndex) => {
    const { _id } = this.props.state.unit
    const { unitElement } = this.props
    const isChecked = e.target.checked
    const op = isChecked ? '$push' : '$pull'
    await units.patch(_id, {
      [op]: {
        [`sections.${sectionIndex.join(
          '.subsections.',
        )}.questions.${questionIndex}.mapping`]: unitElement,
      },
    })
  }

  render() {
    const { formativeTheoryMapping } = this.state
    const { unitElement } = this.props
    return (
      <tbody>
        {formativeTheoryMapping.map((section, i) => [
          <tr>
            <LabelTd colSpan={3}>
              Section {i + 1}
            </LabelTd>
          </tr>,
          ...section.map(({ mapping, sectionIndex, questionIndex }, j) =>
            <tr key={`formativeTheory-${i}${j}`}>
              <td>
                <Checkbox
                  onChange={e =>
                    this.handleChangeTheoryMapping(
                      e,
                      sectionIndex,
                      questionIndex,
                    )}
                  checked={hasElement(unitElement, mapping)}
                />
              </td>
              <td>
                Question {j + 1}
              </td>
              <td>
                {sectionDisplayIndex(sectionIndex)}
              </td>
            </tr>,
          ),
        ])}
      </tbody>
    )
  }
}

export default injectState(FormativeTheoryContent)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/MappingModal/FormativeTheoryContent.js